import { TimeEntryData } from '../interfaces/V1Interface';
import axios from 'axios';

export const sendTimeData = async (timesPayload: { times: TimeEntryData[] }) => {
    try {
      // URL for getting the token for authentication
      const tokenUrl = "https://mobile.api.wcdp.com/api/User/AdminLogin";
      
      // Employee credentials for login
      const employeeId = "27016";
      const password = "27016";
  
      // Make a POST request to get the authentication token using employee credentials
      const tokenResponse = await axios.post(tokenUrl, { employeeId, password });
  
      // Extract the token from the response
      const token = tokenResponse.data.token;
  
      // If the token is not retrieved, log an error and return
      if (!token) {
        console.error("Failed to retrieve token.");
        return;
      }
  
      const dataURL = "https://mobile.api.wcdp.com/api/TimeSheet/SaveManualTimesV2";
  
      console.log("DATA:", timesPayload);  // Log the payload for verification
  
      // Make a POST request to send time data
      const response = await axios.post(
        dataURL,
        timesPayload,  // Send the entire payload with the 'times' field
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the Authorization header
          }
        }
      );
  
      // Handle response if needed
      console.log('Time data sent successfully:', response.data);
      return response.data;
  
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.error('Axios error:', error.response?.data || error.message);
      } else {
        console.error('Unexpected error:', error);
      }
    }
  };  
  